var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path2, _path3, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _path4, _rect69, _path5, _path6, _path7, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "219 -116 538 333",
    enableBackground: "new 219 -116 538 333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.5-82c-26.4,4.7-49.3,24.5-58.2,50.6c-5.2,15-5.4,30-0.9,66.2c3.4,28.1,3.3,31.3-1.5,41.9c-2.8,6.2-11.4,15-17.9,18.5  c-2.6,1.4-4.7,2.8-4.7,3.2c0,1.1,13.2,8.5,21.7,12.2c8.8,3.7,20.7,7.7,30,10.1c25.5,6.4,60.7,6.2,89.7-0.6  c11.5-2.7,31.7-9.6,42.3-14.3l7.9-3.7l-2.9-1.8c-4.4-2.7-10.4-8.8-13.7-14c-7.4-11.7-8.5-24.4-4.7-52.2c1.6-12,2.3-21.6,2.3-35  c0.1-21.5-0.8-25.9-8.1-41c-4-8-6.1-10.9-13.7-18.5c-10.2-10.2-19.6-15.8-32.6-19.5C495.7-82.5,477.9-83.5,469.5-82z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -25.5,
    fill: "none",
    width: 41.4,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 19.2,
    fill: "none",
    width: 68.8,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 325.9,
    y: 32,
    fill: "none",
    width: 12.9,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 6.4,
    fill: "none",
    width: 55.4,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 13,
    fill: "none",
    width: 21.8,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 294.8,
    y: 76.5,
    fill: "none",
    width: 64,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -12.9,
    fill: "none",
    width: 11.6,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -44.6,
    fill: "none",
    width: 65.6,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -38,
    fill: "none",
    width: 76.8,
    height: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    fill: "none",
    width: 25.9,
    height: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: -6.2,
    fill: "none",
    width: 33.4,
    height: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 332.9,
    y: 6.4,
    fill: "none",
    width: 25.9,
    height: 4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 345.8,
    y: 19.2,
    fill: "none",
    width: 12.9,
    height: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -44.6,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -37.9,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -31.7,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 13.1,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -25.4,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 19.3,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -6.2,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -18.7,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -12.8,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 0.1,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 6.5,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: -0.2,
    width: 42.7,
    height: 4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 10.2,
    width: 42.7,
    height: 4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 20.2,
    width: 42.7,
    height: 4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 30.3,
    width: 42.7,
    height: 4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 40.3,
    width: 42.7,
    height: 4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 50.8,
    width: 42.7,
    height: 4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 60.7,
    width: 42.7,
    height: 4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 71,
    width: 42.7,
    height: 4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: 80.8,
    width: 42.7,
    height: 4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 679.5,
    y: -36.2,
    width: 42.7,
    height: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M522.7-75.6c2,1.2,4,2.5,5.9,4C526.7-73.1,524.7-74.4,522.7-75.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M516.5-78.9c2.1,1,4.2,2.1,6.2,3.3C520.7-76.8,518.7-77.9,516.5-78.9z"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 38.3,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 32.3,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 44.9,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 25.7,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 13.1,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -6.2,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 0.1,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 19.3,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 51.2,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 6.5,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 51,
    fill: "none",
    width: 11.6,
    height: 4
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 38.2,
    fill: "none",
    width: 19.7,
    height: 4
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 89.3,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -12.9,
    fill: "none",
    width: 11.6,
    height: 4
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 83,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 64.2,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 70.5,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -25.5,
    fill: "none",
    width: 41.4,
    height: 4
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 76.6,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 57.6,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 675.7,
    y: -44.1,
    fill: "none",
    width: 50.1,
    height: 138.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 89.2,
    fill: "none",
    width: 11.6,
    height: 4
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -37.9,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -31.7,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -18.7,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -25.4,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -12.8,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: -44.6,
    fill: "none",
    width: 3.8,
    height: 3.8
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: -6.2,
    fill: "none",
    width: 33.4,
    height: 4
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    fill: "none",
    width: 25.9,
    height: 4
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 32,
    fill: "none",
    width: 48.5,
    height: 4
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 57.4,
    fill: "none",
    width: 47.1,
    height: 4
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 13,
    fill: "none",
    width: 21.8,
    height: 4
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 25.5,
    fill: "none",
    width: 33.5,
    height: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M437.3-70.7c1.4-1,2.7-2,4.2-3C440-72.7,438.7-71.7,437.3-70.7z"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 63.6,
    fill: "none",
    width: 25.9,
    height: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M441.5-73.6c1.4-0.9,2.9-1.8,4.3-2.7C444.3-75.4,442.9-74.6,441.5-73.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M626.6,179.2c0.3,1,0.6,2.1,0.9,3.2C627.2,181.3,626.9,180.2,626.6,179.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M628.2,185.6c0.2,1.1,0.4,2.2,0.5,3.2C628.6,187.7,628.4,186.7,628.2,185.6z"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 19.2,
    fill: "none",
    width: 68.8,
    height: 4
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 325.9,
    y: 32,
    fill: "none",
    width: 12.9,
    height: 4
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 345.8,
    y: 19.2,
    fill: "none",
    width: 12.9,
    height: 4
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 6.4,
    fill: "none",
    width: 55.4,
    height: 4
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -44.6,
    fill: "none",
    width: 65.6,
    height: 4
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 332.9,
    y: 6.4,
    fill: "none",
    width: 25.9,
    height: 4
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: -38,
    fill: "none",
    width: 76.8,
    height: 4
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 76.5,
    fill: "none",
    width: 16.8,
    height: 4
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 273.8,
    y: 70.4,
    fill: "none",
    width: 25.9,
    height: 4
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 294.8,
    y: 76.5,
    fill: "none",
    width: 64,
    height: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M737,107.7V-59.6H547.2c3.5,4.1,5.6,7.5,8.6,13.4l0,0l0,0c4.1,8.5,6.3,14,7.5,20.7H639v4h-75.2c0.1,0.8,0.2,1.6,0.2,2.5h22  v4h-21.7c0,0.8,0.1,1.5,0.1,2.3h31.5v4h-31.4c0,1.8,0,3.8,0,6c0,5.6-0.1,10.7-0.4,15.5h39.3v4h-39.6c-0.2,2.8-0.5,5.7-0.8,8.7h23.7  v4h-24.1c-0.1,0.9-0.2,1.9-0.4,2.8h10.2v4h-10.7c-0.1,0.6-0.2,1.2-0.2,1.8H591v4h-30c-1,8.8-1.3,15.8-0.9,21.7h16.4v4h-16  c0.1,0.7,0.2,1.5,0.4,2.2h15.6v4h-14.7c0.3,1,0.6,1.9,1,2.8h58.1v4h-56.3c0.3,0.6,0.7,1.2,1,1.8h46.6v4h-43.9  c3.1,4,7.4,8.1,10.6,10.1l2.9,1.8l6.3,3.9l-6.7,3.1l-6.8,3.2v30.1c3.6,1.3,7.1,2.5,10.8,3.6c10.9,3.2,19.4,6.6,25.9,10.7v-45.5H737z   M675.7-44.1h50.1V94.5h-50.1V-44.1z M591,25.5h18.3v4H591V25.5z M594.5,36.3h-17v-4h17V36.3z M614.2,42.2h-18.5v-4h18.5V42.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M393.2,138.3v-30.1c-0.8-0.4-1.6-0.9-2.4-1.3c-8.5-4.8-9.8-6.2-9.8-8.7c0-2.4,1.5-3.9,6.9-6.8c5.9-3.2,14-11.6,16.5-17  c4.3-9.5,4.7-11.5,1.2-40.4c-0.8-6.3-1.4-11.9-1.9-17.1H300.1v-4h103.2c-2-23-1-35.3,3.4-47.9c3.1-9,7.8-17.4,13.6-24.7H233v167.3  h123.5v44.5c5.7-3.2,12.8-5.8,21.5-7.9C381.1,143.5,386.1,141.6,393.2,138.3z M268.8-2.2v-4h33.4v4H268.8z M299.6,0v4h-25.9V0H299.6  z M273.8,13h21.8v4h-21.8V13z M273.8,25.5h33.5v4h-33.5V25.5z M273.8,32h48.5v4h-48.5V32z M269.2,61.4v-4h47.1v4H269.2z M299.6,63.6  v4h-25.9v-4H299.6z M273.8,76.5h16.8v4h-16.8V76.5z M273.8,74.4v-4h25.9v4H273.8z M294.8,76.5h64v4h-64V76.5z M305.1,74.4v-4h76.2v4  H305.1z M305.1,67.6v-4h76.2v4H305.1z M325.9,36v-4h12.9v4H325.9z M345.8,19.2h12.9v4h-12.9V19.2z M342.5,19.2v4h-68.8v-4H342.5z   M329.1,10.4h-55.4v-4h55.4V10.4z M358.7,10.4h-25.9v-4h25.9V10.4z M265.8-44.6h65.6v4h-65.6V-44.6z M265.8-38h76.8v4h-76.8V-38z   M265.8-25.5h41.4v4h-41.4V-25.5z M265.8-12.9h11.6v4h-11.6V-12.9z M265.8,38.2h19.7v4h-19.7V38.2z M265.8,51h11.6v4h-11.6V51z   M262.6,93.2h-3.8v-3.8h3.8V93.2z M262.6,86.8h-3.8V83h3.8V86.8z M262.6,80.4h-3.8v-3.8h3.8V80.4z M262.6,74.3h-3.8v-3.8h3.8V74.3z   M262.6,68h-3.8v-3.8h3.8V68z M262.6,61.4h-3.8v-3.8h3.8V61.4z M262.6,55h-3.8v-3.8h3.8V55z M262.6,48.7h-3.8v-3.8h3.8V48.7z   M262.6,42.1h-3.8v-3.8h3.8V42.1z M262.6,36.2h-3.8v-3.8h3.8V36.2z M262.6,29.5h-3.8v-3.8h3.8V29.5z M262.6,23.2h-3.8v-3.8h3.8V23.2  z M262.6,16.9h-3.8v-3.8h3.8V16.9z M262.6,10.3h-3.8V6.5h3.8V10.3z M262.6,3.9h-3.8V0.1h3.8V3.9z M262.6-2.3h-3.8v-3.8h3.8V-2.3z   M262.6-9h-3.8v-3.8h3.8V-9z M262.6-14.9h-3.8v-3.8h3.8V-14.9z M262.6-21.6h-3.8v-3.8h3.8V-21.6z M262.6-27.9h-3.8v-3.8h3.8V-27.9z   M262.6-34.1h-3.8v-3.8h3.8V-34.1z M262.6-40.8h-3.8v-3.8h3.8V-40.8z M277.4,93.2h-11.6v-4h11.6V93.2z M273.8,86.9v-4h119.5v4H273.8  z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M628.7,188.8c-0.1-1.1-0.3-2.1-0.5-3.2s-0.4-2.2-0.7-3.2c-0.3-1.1-0.6-2.1-0.9-3.2c-0.5-1.5-1-3-1.5-4.4  c-0.5-1.4-1.1-2.6-1.7-3.7c-1.1-2.1-2.5-4.1-4-5.9c-0.8-0.9-1.6-1.8-2.5-2.7c-0.6-0.6-1.2-1.1-1.9-1.7c-0.3-0.3-0.7-0.6-1-0.8  c-0.7-0.5-1.4-1.1-2.1-1.6c-0.2-0.1-0.4-0.3-0.5-0.4c-6.5-4.5-15.3-8.2-27.1-11.7c-3.3-1-6.5-2-9.7-3.2c-9.6-3.4-19-7.8-30.3-14  l-9-4.9l-7.8,1.6c-2.1,0.4-4.2,0.8-6.2,1.2c-0.7,0.1-1.3,0.2-2,0.4c-1.4,0.2-2.7,0.5-4.1,0.7c-0.8,0.1-1.6,0.2-2.4,0.4  c-1.2,0.2-2.4,0.4-3.6,0.5c-0.8,0.1-1.7,0.2-2.5,0.3c-1.1,0.1-2.2,0.3-3.3,0.4c-0.9,0.1-1.7,0.2-2.6,0.3c-1.1,0.1-2.1,0.2-3.2,0.3  c-0.9,0.1-1.7,0.1-2.6,0.2c-1,0.1-2.1,0.2-3.1,0.2c-0.9,0-1.7,0.1-2.6,0.1c-1,0-2,0.1-3,0.1c-0.9,0-1.7,0-2.6,0c-0.7,0-1.5,0-2.2,0  c-0.3,0-0.5,0-0.8,0c-1,0-2.1,0-3.1,0c-0.9,0-1.8,0-2.7-0.1c-1,0-2.1-0.1-3.1-0.1c-0.9,0-1.8-0.1-2.7-0.1c-1.1-0.1-2.1-0.2-3.2-0.3  c-0.9-0.1-1.8-0.1-2.7-0.2c-1.1-0.1-2.2-0.2-3.3-0.4c-0.9-0.1-1.8-0.2-2.7-0.3c-1.1-0.1-2.3-0.3-3.4-0.5c-0.9-0.1-1.7-0.2-2.6-0.4  c-1.2-0.2-2.4-0.4-3.7-0.6c-0.8-0.1-1.7-0.3-2.5-0.4c-1.4-0.2-2.8-0.5-4.2-0.8c-0.7-0.1-1.4-0.3-2.1-0.4c-2.1-0.4-4.3-0.9-6.5-1.4  c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.4,0.1  c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2,0.1-0.4,0.2-0.6,0.2  c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0.1-0.4,0.2-0.7,0.3c-0.2,0.1-0.4,0.2-0.7,0.3c-0.2,0.1-0.5,0.2-0.8,0.3c-0.2,0.1-0.5,0.2-0.7,0.3  c-0.3,0.1-0.6,0.2-0.8,0.4c-0.3,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.1-0.5,0.2-0.8,0.4c-0.3,0.1-0.7,0.3-1,0.5  c-0.3,0.1-0.6,0.3-0.9,0.4c-0.3,0.2-0.7,0.3-1.1,0.5c-0.3,0.1-0.6,0.3-0.9,0.4c-0.4,0.2-0.8,0.4-1.2,0.6c-0.3,0.1-0.6,0.3-0.9,0.4  c-0.4,0.2-0.8,0.4-1.3,0.6c-0.3,0.2-0.6,0.3-1,0.5c-0.5,0.2-1,0.5-1.5,0.7c-0.3,0.1-0.5,0.3-0.8,0.4c-0.8,0.4-1.6,0.8-2.4,1.2  c-2.8,1.4-5.3,2.6-7.8,3.8c-1.6,0.8-3.1,1.5-4.6,2.2c-1,0.5-1.9,0.9-2.9,1.3c-1.1,0.5-2.1,1-3.1,1.4c-1.2,0.5-2.4,1-3.4,1.4  c-1.1,0.4-2.1,0.8-3,1.2c-0.9,0.3-1.8,0.6-2.6,0.9s-1.5,0.4-2.2,0.6c-4.4,1-8.3,2.2-11.9,3.6c-0.7,0.3-1.4,0.5-2.1,0.8  c-1.4,0.6-2.7,1.1-3.9,1.8c-1.6,0.8-3.1,1.7-4.6,2.6c-0.2,0.1-0.4,0.2-0.6,0.4c-1.1,0.7-2,1.4-3,2.2c-1.4,1.1-2.7,2.4-3.8,3.7  c-6.2,6.9-8.8,16.2-8.8,28.7v9h90.8c50,0,115-0.3,144.4-0.7l53.6-0.6v-4.7C629.2,192.9,629,190.9,628.7,188.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M615,160.8c0.6,0.6,1.3,1.1,1.9,1.7C616.3,161.9,615.7,161.4,615,160.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M611.9,158.4c0.7,0.5,1.4,1.1,2.1,1.6C613.4,159.4,612.7,158.9,611.9,158.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M629.2,194.7c0-1.8-0.2-3.8-0.5-5.9C629,190.9,629.2,192.9,629.2,194.7L629.2,194.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M352.9,159.4c0.9-0.8,1.9-1.5,3-2.2C354.9,157.9,353.9,158.7,352.9,159.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M625.1,174.8c0.5,1.4,1.1,2.8,1.5,4.4C626.1,177.7,625.6,176.2,625.1,174.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M625.1,174.8c-0.5-1.4-1.1-2.6-1.7-3.7c-1.1-2.1-2.5-4.1-4-5.9c1.5,1.9,2.9,3.8,4,5.9  C624,172.2,624.5,173.4,625.1,174.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M352.9,159.4c-1.4,1.1-2.7,2.4-3.8,3.7C350.2,161.8,351.5,160.6,352.9,159.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEBAC7",
    d: "M361.1,154.3c1.2-0.6,2.5-1.2,3.9-1.8C363.6,153.1,362.3,153.7,361.1,154.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.ce4b83b045dc1816f6c618468303d089.svg";
export { ForwardRef as ReactComponent };